import connection from "../../utils/connection";

const getConfiguraciones = async () => {
    let response = {};
    try {
        const responseGet = await connection({
            url: `/configuracion`,
        });
        response.data = responseGet;
    } catch (error) {
        console.error("catch service", error);
        response = error.response;
    }

    return response;
};

export default getConfiguraciones;
